// extracted by css-extract-rspack-plugin
export default {"vacancyItem":"vacancy-item--A703ZHe_EUgNJvcU"};